"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _getConditionsName = require("../get-conditions-name");
var _getRewardsPortableText = _interopRequireDefault(require("../../shared/get-rewards-portable-text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var getSubtext = function getSubtext(offer) {
  var isRewardsList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var additionalConditions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  if ((0, _fp.isNil)(offer)) return null;
  var conditions = (0, _getConditionsName.getConditionsGroupName)(offer);
  var specificConditions = (0, _getConditionsName.getSpecificConditionsGroupName)(offer);
  var rewardsList = [[{
    value: 'For '
  }, conditions && {
    value: (0, _fp.lowerCase)(conditions.value)
  }, conditions && specificConditions && {
    value: ' '
  }, specificConditions]].concat(_toConsumableArray((0, _getRewardsPortableText["default"])({
    offer: offer
  }, true)), [additionalConditions && [{
    value: additionalConditions
  }]]);
  var rewardsText = [conditions, specificConditions && {
    value: ' '
  }, specificConditions, {
    value: ' can get '
  }].concat(_toConsumableArray((0, _getRewardsPortableText["default"])({
    offer: offer
  })), [additionalConditions && {
    value: " ".concat(additionalConditions)
  }]);
  return {
    value: isRewardsList ? (0, _fp.compact)(rewardsList) : (0, _fp.compact)(rewardsText)
  };
};
var _default = exports["default"] = getSubtext;
module.exports = exports.default;